<div class="container card" *ngIf="isProfileLoaded">
  <h3 [ngClass]="{ 'main-title': isEnglish, 'main-title-ar': isArabic }">
    {{ 'UserProfile.ProfileTitle' | translate }}
    <span *ngIf="isPerson"> - {{ 'UserProfile.Person' | translate }}</span>
    <span *ngIf="!isPerson"> - {{ 'UserProfile.Company' | translate }}</span>
  </h3>

  <app-bs-alert
    *ngIf="showError"
    class="has-error"
    [key]="this.errorMessageKey"
    [alert]="{ display: true }"
    [importance]="importance.Danger"
  >
  </app-bs-alert>

  <app-bs-alert
    *ngIf="showSuccess"
    [key]="successMessageKey"
    [alert]="{ display: true }"
    [importance]="importance.Success"
  >
  </app-bs-alert>

  <form [formGroup]="form">
    <div id="profileAccordion">
      <div class="card">
        <div
          class="card-header"
          id="AccountInfoHeader"
          data-toggle="collapse"
          data-target="#AccountInfo"
          aria-expanded="true"
          aria-controls="AccountInfo"
        >
          <h5 class="mb-0">
            <a class="btn-header-link">
              {{ 'UserProfile.AccountInfo' | translate }}
            </a>
          </h5>
        </div>

        <div
          id="AccountInfo"
          class="collapse show"
          aria-labelledby="AccountInfoHeader"
          data-parent="#profileAccordion"
        >
          <div class="card-body">
            <app-profile-account-info [form]="form"> </app-profile-account-info>
          </div>
        </div>
      </div>
      <div *ngIf="isPerson" class="card">
        <div
          class="card-header"
          id="PersonalInfoHeader"
          data-toggle="collapse"
          data-target="#PersonalInfo"
          aria-expanded="true"
          aria-controls="PersonalInfo"
        >
          <h5 class="mb-0">
            <a class="btn-header-link">
              {{ 'UserProfile.PersonalInfo' | translate }}
            </a>
          </h5>
        </div>

        <div
          id="PersonalInfo"
          class="collapse"
          aria-labelledby="PersonalInfoHeader"
          data-parent="#profileAccordion"
        >
          <div class="card-body">
            <app-profile-person-info
              [lookups]="lookups"
              [form]="form"
              [isVerified]="person?.IsVerified"
              [isRegistered]="true"
            >
            </app-profile-person-info>
          </div>
        </div>
      </div>

      <div *ngIf="!isPerson" class="card">
        <div
          class="card-header"
          id="CompanyInfoHeader"
          data-toggle="collapse"
          data-target="#CompanyInfo"
          aria-expanded="true"
          aria-controls="CompanyInfo"
        >
          <h5 class="mb-0">
            <a class="btn-header-link">
              {{ 'UserProfile.CompanyInfo' | translate }}
            </a>
          </h5>
        </div>

        <div
          id="CompanyInfo"
          class="collapse"
          aria-labelledby="CompanyInfoHeader"
          data-parent="#profileAccordion"
        >
          <div class="card-body">
            <profile-company-info
              [isRegistered]="true"
              [lookups]="lookups"
              [form]="form"
            >
            </profile-company-info>
          </div>
        </div>
      </div>

      <div *ngIf="!isPerson" class="card">
        <div
          class="card-header"
          id="CompanyLocationHeader"
          data-toggle="collapse"
          data-target="#CompanyLocation"
          aria-expanded="false"
          aria-controls="CompanyLocation"
        >
          <h5 class="mb-0">
            <a class="btn-header-link">
              {{ 'UserProfile.CompanyLocation' | translate }}
            </a>
          </h5>
        </div>

        <div
          id="CompanyLocation"
          class="collapse"
          aria-labelledby="CompanyLocationHeader"
          data-parent="#profileAccordion"
        >
          <div class="card-body">
            <profile-company-location [form]="form"> </profile-company-location>
          </div>
        </div>
      </div>

      <div *ngIf="!isPerson" class="card">
        <div
          class="card-header"
          id="CompanyOwnersHeader"
          data-toggle="collapse"
          data-target="#CompanyOwners"
          aria-expanded="false"
          aria-controls="CompanyOwners"
        >
          <h5 class="mb-0">
            <a class="btn-header-link">
              {{ 'UserProfile.CompanyOwners' | translate }}
            </a>
          </h5>
        </div>

        <div
          id="CompanyOwners"
          class="collapse"
          aria-labelledby="CompanyOwnersHeader"
          data-parent="#profileAccordion"
        >
          <div class="card-body">
            <profile-company-owners
              [mainForm]="form"
              [owners]="authority?.Owners"
              [lookups]="lookups"
              [isRegistered]="true"
              [isPowerUser]="isOwner"
            >
            </profile-company-owners>
          </div>
        </div>
      </div>

      <div class="card">
        <div
          class="card-header"
          id="AgentsInfoHeader"
          data-toggle="collapse"
          data-target="#AgentsInfo"
          aria-expanded="false"
          aria-controls="AgentsInfo"
        >
          <h5 class="mb-0">
            <a class="btn-header-link">
              {{ 'UserProfile.AgentsInfo' | translate }}
            </a>
          </h5>
        </div>
        <div
          id="AgentsInfo"
          class="collapse"
          aria-labelledby="AgentsInfoHeader"
          data-parent="#profileAccordion"
        >
          <div class="card-body">
            <profile-agents
              [isRegistered]="true"
              [isOwner]="isOwner"
              [agents]="isPerson ? person?.Agents : authority?.Agents"
              [mainForm]="form"
              [lookups]="lookups"
            >
            </profile-agents>
          </div>
        </div>
      </div>

      <div class="card">
        <div
          class="card-header"
          id="ContactInfoHeader"
          data-toggle="collapse"
          data-target="#ContactInfo"
          aria-expanded="false"
          aria-controls="ContactInfo"
        >
          <h5 class="mb-0">
            <a class="btn-header-link">
              {{ 'UserProfile.ContactInfo' | translate }}
            </a>
          </h5>
        </div>
        <div
          id="ContactInfo"
          class="collapse"
          aria-labelledby="ContactInfoHeader"
          data-parent="#profileAccordion"
        >
          <div class="card-body">
            <app-profile-contact-info
              [isPerson]="isPerson"
              [lookups]="lookups"
              [form]="form"
              [isRegistered]="true"
            >
            </app-profile-contact-info>
          </div>
        </div>
      </div>
    </div>
    <div class="text-right ds-btns pt-1">
      <button
        type="button"
        class="ds-btn ds-btn-primary ds-btn-small"
        (click)="save()"
      >
        {{ 'UserProfile.SaveProfile' | translate }}
      </button>
    </div>
  </form>
</div>
